import { useEffect } from 'react'

import { isInsufficientPermissionsError, showToast } from '@/utils/toastMessage'

/**
 * Hook for standardized error handling in React Query mutations and queries.
 * Provides consistent toast notifications for errors.
 *
 * @param isError - Whether an error occurred
 * @param customMessage - Optional custom error message
 * @param severity - Toast severity, defaults to 'error'
 * @param error - The underlying error, if available. Used to skip toasting an
 * INSUFFICIENT_PERMISSIONS error a second time — the global API interceptor already
 * shows a toast for that case.
 */
export const useErrorHandler = (
  isError: boolean,
  customMessage?: string,
  severity: 'error' | 'warn' | 'info' | 'success' = 'error',
  error?: unknown
) => {
  useEffect(() => {
    if (isError) {
      if (isInsufficientPermissionsError(error)) return
      showToast({
        severity,
        detail: customMessage || 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
      })
    }
  }, [isError, customMessage, severity, error])
}
